import React, { useContext, useEffect, useState } from 'react';
import { UserContext } from '../../App';
import { supabase } from '../../utils/supabaseClient';
import { Medal, Star, Target } from 'lucide-react';
import { AvatarDisplay } from '../../utils/avatars';

export default function PersonalFootprintWidget() {
  const { currentUser } = useContext(UserContext);
  const [joinedCount, setJoinedCount] = useState(0);

  useEffect(() => {
    if (!currentUser?.id) return;

    async function fetchStats() {
      const { count } = await supabase
        .from('event_participants')
        .select('*', { count: 'exact', head: true })
        .eq('user_id', currentUser.id)
        .eq('status', 'approved');
      
      if (count !== null) setJoinedCount(count);
    }
    fetchStats();
  }, [currentUser]);

  if (!currentUser?.profile) return null;

  const { total_points, earned_badges } = currentUser.profile;
  const badgeCount = Array.isArray(earned_badges) ? earned_badges.length : 0;
  const points = total_points || 0;

  return (
    <div style={{
      background: 'linear-gradient(135deg, #1e293b 0%, #0f172a 100%)',
      borderRadius: '20px',
      padding: '20px',
      color: 'white',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      boxShadow: '0 10px 25px rgba(15, 23, 42, 0.2)',
      marginBottom: '24px'
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
        <div style={{ width: '56px', height: '56px', borderRadius: '50%', overflow: 'hidden', border: '2px solid rgba(255,255,255,0.2)', flexShrink: 0 }}>
          <AvatarDisplay avatarId={currentUser.profile.avatar} size={56} />
        </div>
        <div>
          <div style={{ fontSize: '14px', color: '#94a3b8', fontWeight: '600', marginBottom: '4px' }}>我的 JoinU 足跡</div>
          <div style={{ fontSize: '18px', fontWeight: '800', display: 'flex', alignItems: 'center', gap: '12px' }}>
            <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
              <Target size={18} color="#60a5fa" /> {joinedCount} 場活動
            </span>
            <span style={{ color: 'rgba(255,255,255,0.2)' }}>|</span>
            <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
              <Star size={18} color="#fbbf24" /> {points} 分
            </span>
            {badgeCount > 0 && (
              <>
                <span style={{ color: 'rgba(255,255,255,0.2)' }}>|</span>
                <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                  <Medal size={18} color="#a78bfa" /> {badgeCount} 勳章
                </span>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
